export default {
  links: [
    { icon: "facebook", url: "https://www.facebook.com/mikealbertfleetsolutions/" },
    { icon: "linkedin", url: "https://www.linkedin.com/company/mike-albert-fleet-solutions/" },
    { icon: "twitter", url: "https://twitter.com/MAmobility" },
    { icon: "youtube", url: "https://www.youtube.com/channel/UCmTQ847QZixnbCF8VGeH3Ng/featured" },
    { icon: "instagram", url: "https://www.instagram.com/mikealbertmobility/" }
  ]
}
